import React, { useState, useEffect } from 'react';

import useTranslate from '../../../common/hooks/useTranslate';
import { useDispatch } from 'react-redux';
import { getImpersonate } from '../../services/userService';
import { debounce } from 'lodash';

import { POPUP } from '../../../redux/types';

import { Grid, GridColumn } from '@progress/kendo-react-grid';
import Main from '../../layout/main/main';
import ComponentLoader from '../../ui/loaders/componentLoader/componentLoader';
import SelectCell from '../components/cells/selectCell/selectCell';

import './impersonate.scss';

const Impersonate: React.FC = () => {
  const [impersonateList, setImpersonateList] = useState<any[]>([]);
  const [impersonatorName, setImpersonatorName] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  const { t } = useTranslate();
  const dispatch = useDispatch();

  const handleInputChange = debounce((e) => {
    setImpersonatorName(e.target.value);
  }, 200);

  useEffect(() => {
    setLoading(true);
    impersonatorName ? getImpersonate(impersonatorName).then((r) => setImpersonateList(r.data)).catch((err) => dispatch({
      type: POPUP.SET_SERVER_ERROR,
      payload: err.message,
    })) : getImpersonate().then((r) => setImpersonateList(r.data)).catch(() => dispatch({ type: POPUP.SET_SERVER_ERROR }));
    setLoading(false);
  }, [impersonatorName]);

  return (
    <Main className='impersonalisation-wrapper table' title={t('IMPERSONATE.PAGE_TITLE')}>
      <div className={'search-user-wrapper'}>
        <input className='search-input' type='search' placeholder={t('IMPERSONATE.PLACEHOLDER_SEARCH')}
               onChange={handleInputChange} />
      </div>

      {loading ? (
        <div className='loader-wrapper'>
          <ComponentLoader />
        </div>
      ) : (
        <Grid data={impersonateList} className='impersonate-grid table'>
          <GridColumn field='subjectId' title={t('IMPERSONATE.COLUMN_SELECT')} cell={SelectCell} width={150} />
          <GridColumn field='name' title={t('IMPERSONATE.COLUMN_NAME')} />
          <GridColumn field='userName' title={t('IMPERSONATE.COLUMN_USERNAME')} />
        </Grid>
      )}
    </Main>
  );
};

export default Impersonate;
